import { useState } from 'react'
import { useNews } from '@/hooks/useData'

export default function News() {
  const { data: newsData } = useNews()
  const [selectedCategory, setSelectedCategory] = useState<string>('')

  const filteredNews = selectedCategory
    ? newsData?.news.filter(news => news.category === selectedCategory)
    : newsData?.news

  return (
    <div className="min-h-screen bg-white">
      {/* 页面标题 */}
      <section className="bg-gradient-to-r from-primary-600 to-primary-800 text-white py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-4">环保要闻</h1>
          <p className="text-xl text-primary-100">
            了解最新环保政策、行业动态和技术前沿
          </p>
        </div>
      </section>

      {/* 新闻分类筛选 */}
      <section className="py-8 bg-secondary-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-4 justify-center">
            <button
              onClick={() => setSelectedCategory('')}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                selectedCategory === ''
                  ? 'bg-primary-600 text-white'
                  : 'bg-white text-secondary-600 hover:bg-primary-50'
              }`}
            >
              全部新闻
            </button>
            {newsData?.categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.name)}
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  selectedCategory === category.name
                    ? 'bg-primary-600 text-white'
                    : 'bg-white text-secondary-600 hover:bg-primary-50'
                }`}
              >
                {category.name} ({category.count})
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* 新闻列表 */}
      <section className="py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredNews?.map((news) => (
              <div key={news.id} className="card">
                <img
                  src={news.image}
                  alt={news.title}
                  className="w-full h-48 object-cover rounded-lg mb-4"
                />
                <div className="flex items-center text-sm text-secondary-500 mb-2">
                  <span className="px-2 py-1 bg-primary-100 text-primary-700 rounded text-xs">
                    {news.category}
                  </span>
                  <span className="mx-2">•</span>
                  <span>{news.publishDate}</span>
                  <span className="mx-2">•</span>
                  <span>{news.views} 阅读</span>
                </div>
                <h3 className="text-lg font-semibold mb-2 line-clamp-2">
                  {news.title}
                </h3>
                <p className="text-secondary-600 mb-4 line-clamp-3">
                  {news.summary}
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {news.tags.map((tag, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 bg-secondary-100 text-secondary-700 text-xs rounded"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="text-sm text-secondary-500">
                  <span>作者: {news.author}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
} 